import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function BoundContext({ children }) {
    const context = useBoundContext()
    return children(context)
}
